"use client";

import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { apiClient } from "@/lib/client";
import { SigninWithEmailRequestSchema, type SigninWithEmailRequestType } from "@/types/auth";
import { zodResolver } from "@hookform/resolvers/zod";
import style from "@routes/signin/index.module.scss";
import { useRouter } from "next/navigation";
import { useForm } from "react-hook-form";
import { toast } from "sonner";

export const SigninForm = () => {
  const router = useRouter();
  const form = useForm<SigninWithEmailRequestType>({
    resolver: zodResolver(SigninWithEmailRequestSchema),
    defaultValues: {
      email: "",
      password: ""
    }
  });

  const handleSubmit = async (request: SigninWithEmailRequestType) => {
    try {
      const response = await apiClient.signinWithEmail({ ...request });
      console.debug(response);
      toast("サインインしました");
      router.push("/home");
      router.refresh();
    } catch (err) {
      toast.error("サインインに失敗しました", { description: err.response.data.message });
      console.error(err);
    }
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(handleSubmit)} className={style.form}>
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel>メールアドレス</FormLabel>
              <FormControl>
                <Input placeholder="a@sample.com" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="password"
          render={({ field }) => (
            <FormItem>
              <FormLabel>パスワード</FormLabel>
              <FormControl>
                <Input type="password" placeholder="*********" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <Button type="submit" className={style.submit_button}>
          サインイン
        </Button>
      </form>
    </Form>
  );
};
